import Center from '@zenbusiness/zui/Center';

import * as ROUTES from '#client/constants/routes';

import AppShareButtons from './AppShareButtons';
import { DownloadContainer, DownloadHeading, Image, MaybeLaterButton } from './Download.styles';

const config = {
  title: 'Track your formation in our app.',
  textButton: 'Maybe later',
  imgSrc: '/s2/vector/mobile-app.svg',
  imgAlt: 'Track your formation in our app.',
};

const Download = () => (
  <Center>
    <DownloadContainer>
      <Image alt={config.imgAlt} src={config.imgSrc} />
      <DownloadHeading>{config.title}</DownloadHeading>
      <AppShareButtons />
      <MaybeLaterButton to={ROUTES.dashboard}>{config.textButton}</MaybeLaterButton>
    </DownloadContainer>
  </Center>
);

export default Download;
